import BaseShopLayout from "@shop/components/BaseShopLayout";
import ConsultingSelection from "@shop/components/ConsultingSelection";
import ExtraPagesSelection from "@shop/components/ExtraPagesSelection";

const ExtraPagesShopPage = () => {
    return (
        <BaseShopLayout
            title={"Hier kannst Du zusätzliches Seitenkontingent bestellen."}
            description={
                "Mit dem Extra kannst Du Dein bestehendes Kontingent einmalig erweitern. Erhöhe Deine zu befragenden Seiten, um noch mehr Antworten auf Deine Fragen zu erhalten."
            }
            useOuterScroll
        >
            <ExtraPagesSelection />
        </BaseShopLayout>
    );
};

export default ExtraPagesShopPage;
